import { render, staticRenderFns } from "./WxServiceNew.vue?vue&type=template&id=7b7a625a"
import script from "./WxServiceNew.vue?vue&type=script&lang=js"
export * from "./WxServiceNew.vue?vue&type=script&lang=js"
import style0 from "./WxServiceNew.vue?vue&type=style&index=0&id=7b7a625a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports